export default __webpack_public_path__ + "static/media/colored-offer-unpublish-icon.e4d32494.svg";